import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import messagingService from 'services/messagingService';

export const fetchTotalUnreadCount = createAsyncThunk(
  'messaging/fetchTotalUnreadCount',
  async (role, { rejectWithValue }) => {
    try {
      const response = await messagingService.getConversations(role);
      if (response.success) {
        const conversations = response.data.conversations || [];
        const totalUnread = conversations.reduce((sum, conv) => sum + (conv.unread_count || 0), 0);
        return totalUnread;
      }
      return rejectWithValue(response.error);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  unreadCount: 0,
  loading: false,
  error: null,
};

const messagingSlice = createSlice({
  name: 'messaging',
  initialState,
  reducers: {
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    incrementUnreadCount: (state) => {
      state.unreadCount += 1;
    },
    decrementUnreadCount: (state, action) => {
      // If we decrement by a specific amount (e.g. marking a conversation as read)
      const count = action.payload || 1;
      state.unreadCount = Math.max(0, state.unreadCount - count);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTotalUnreadCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTotalUnreadCount.fulfilled, (state, action) => {
        state.loading = false;
        state.unreadCount = action.payload;
      })
      .addCase(fetchTotalUnreadCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setUnreadCount, incrementUnreadCount, decrementUnreadCount } = messagingSlice.actions;
export default messagingSlice.reducer;
